
<template>
  <el-card v-loading="loading" class="page">
    <el-form v-if="showForm" :inline="true" ref="form" :model="form" label-width="120px">
      <el-form-item label="Contract Name" prop="name">
        <el-input v-model="form.name"></el-input>
      </el-form-item>
      <el-form-item v-if="showForm">
        <el-button type="primary" @click="onSubmit">Create</el-button>
      </el-form-item>
    </el-form>
    <el-button class="button" v-else type="primary" circle icon='el-icon-plus' @click="showForm = true"/>
    <el-table
      :data="tableData"
      stripe
      style="width: 100%">
    <el-table-column
      prop="name"
      label="Contract Name"
      width="300">
    </el-table-column>
    <el-table-column
      prop="programs"
      label="Programs">
      <template slot-scope="scope">
        <ProgramTags :contractId="scope.row.id"/>
      </template>
    </el-table-column>
  </el-table>

  </el-card>
</template>

<script>
  import {database} from '../main.js'
  import ProgramTags from './ProgramTags.vue'
  export default {
    components: {
      ProgramTags
    },
    data () {
      return {
        loading: false,
        showForm: false,
        form: {
          name: ''
        },
        data: {}
      }
    },
    created () {
      this.loading = true
      database.ref('/contracts').on('value', data => {
        const obj = data.val()
        this.data = obj
      })
      setTimeout(() => {
        this.loading = false
      }, 600)
    },
    computed: {
      tableData () {
        return Object.keys(this.data).map(key => {
          const programs = this.data[key].programs
          /* Object.keys(programs).map(key => programs[key]) */
          console.log('programs', programs)
          return {
            name: this.data[key].name,
            id: key,
            programs: programs
          }
        })
      }
    },
    methods: {
      onSubmit () {
        const data = {...this.form}
        const newContract = database.ref('/contracts').push()
        newContract.set(data)
        this.$refs.form.resetFields()
        this.showForm = false
      },
      removeProgram (item) {
        var index = this.form.programs.indexOf(item);
        if (index !== -1) {
          this.form.programs.splice(index, 1);
        }
      },
      addProgram () {
        this.form.programs.push({
          key: Date.now(),
          value: ''
        });
      }
    }
  }
</script>
<style scoped>
  .button {
    margin-bottom: 23px;
  }
  .tag {
    min-width: 100px;
    text-align: center;
    margin-right: 20px;
  }
  .page {
    position: absolute;
    overflow: scroll;
    height: calc(100vh - 120px);
    width: calc(100vw - 240px)
  }
</style>



// WEBPACK FOOTER //
// src/components/AddContract.vue